import { useEffect, useState } from 'react'
import { EntityWithIdAndDescription, QueryStatus } from 'src/types'
import { HttpCacheWorkflow } from 'src/http/workflow/httpCacheWorkflow'
import {HttpSystems} from "../../../http/workflow/httpSystems";
import {HttpSystemsNewByGroup} from "../../../http/group/httpSystemsNewByGroup";
import {Sistema} from "../types";

export const useSistemas = (cache?: boolean, countryCode?: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [sistemas, setSistemas] = useState<Sistema[]>()

    useEffect(() => {
        const fetchData = () => {
            setStatus(QueryStatus.Loading)

            if (cache) {
                HttpCacheWorkflow.getSistemasTipos()
                    .then(res => {
                        setSistemas(res)
                        setStatus(QueryStatus.Success)
                    })
                    .catch(() => setStatus(QueryStatus.Error))
            } else if (countryCode !== undefined) {
                HttpSystemsNewByGroup.getSystemsByCountry(countryCode)
                    .then(res => {
                        setSistemas(res)
                        setStatus(QueryStatus.Success)
                    })
                    .catch(() => setStatus(QueryStatus.Error))
            } else {
                HttpSystems.getSystemTypesByUser()
                    .then(res => {
                        setSistemas(res)
                        setStatus(QueryStatus.Success)
                    })
                    .catch(() => setStatus(QueryStatus.Error))
            }
        }

        fetchData()

    }, [cache, countryCode])

    return { status, sistemas }
}